import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { formatTeamPayload } from './ClaimsProcessors.types';

const useTeamQuery = (id?: string, enabled?: boolean) => {
  const { isLoading, data } = useQuery(
    [API_URL.CLAIMS_TEAMS_BY_CLAIMS_TEAM_ID(id || ''), enabled],
    () => api.get(API_URL.CLAIMS_TEAMS_BY_CLAIMS_TEAM_ID(id || '')),
    { enabled: Boolean(enabled && id) }
  );

  const team = useMemo(() => {
    if (!data?.data) return undefined;
    return formatTeamPayload(data.data);
  }, [data]);

  return {
    team,
    isLoading,
  };
};

export default useTeamQuery;
